import get from 'lodash/get';
import size from 'lodash/size';
import omit from 'lodash/omit';
import invert from 'lodash/invert';
import reduce from 'lodash/reduce';
import merge from 'lodash/merge';
import mapValues from 'lodash/mapValues';
import cloneDeep from 'lodash/cloneDeep';
import { arrayed } from 'mythil/array';
import { modify } from 'mythil/object';
import createSuccessPromiseThunk from "~/rx/lib/createPromiseThunk";
import apiFetchModelConfigs from "~/backend/fetchModelConfigs";
import loadModels from "~/reducers/helpers/loadModels";
import {findSubview, getSubviewsByModelName as getSubviewsByModelNameState, getTableSettingsIdentifier, getModelOrNull as getStateModelOrNull} from '~/stateGetter';
import identify from "~/identify";
import authenticatedRequest from "~/backend/authenticatedRequest";



let { execute, types, initialState, ...modelConfigs } = createSuccessPromiseThunk({
    name: 'modelConfigs',
    func: async ({getConfig, modelNames, dispatch}) => {
        return apiFetchModelConfigs(getConfig().baseUrl, modelNames, (foo) => authenticatedRequest(foo, dispatch));
    },
});

const typeMap = invert(types);

let originalExecute = execute;
execute = (modelNames, props = { isForCache: false, }) => {
    modelNames = arrayed(modelNames);
    return originalExecute({modelNames}, {modelNames, ...props});
};

let originalReduce = modelConfigs.reduce;
let reduceModelConfigs = (modelConfigs, action) => {
    if(!(action.type in typeMap)) {
        return modelConfigs;
    }

    for(let modelName of action.modelNames) {
        switch(action.type) {
            case types.SUCCESS:
                modelConfigs = modify(modelConfigs, modelName, (configState) => {
                    return {
                        ...configState,
                        finished_at: Date.now(),
                        value: action.value[modelName],
                        status: identify.STATUS_SUCCESS
                    }
                });
                break;
            default:
                modelConfigs = modify(modelConfigs, modelName, (configState) => {
                    if(!configState) { configState = initialState; }

                    if(action.type === types.PENDING && action.isForCache) {
                        return configState;
                    }

                    return originalReduce(configState, action);
                });
                break;
        }
    }

    return modelConfigs;
};

const reduceModelCacheStatus = (state, action) => {
    if(!action.isForCache) { return state; }
    if(!(action.type in typeMap)) { return state; }

    if(action.type === types.SUCCESS) {
        return {
            ...originalReduce(state, action),
            value: null
        }
    }

    return originalReduce(state, action);  
};

const reduceLoadedModelsUi = (ui, action, state) => {
    if(!(action.type in typeMap)) {
        return ui;
    }


    switch(action.type) {
        case types.SUCCESS:
            const getSubviewsByModelName = (modelName) => {
                if(modelName in action.value) {
                    return action.value[modelName].dataModel.item.subviews
                }

                let subviews = getSubviewsByModelNameState(state, modelName);

                return subviews;
            };

            const getModelOrNull = (modelName) => {
                if(modelName in action.value) {
                    return action.value[modelName];
                }

                return getStateModelOrNull(state, modelName);
            };

            ui = modify(ui, 'loadedModels', (loadedModels) => {
                return mapValues(loadedModels, (model) => {
                    if(!model.subviewAbbreviation) { return model; }

                    let parentModelName = loadedModels[model.parentModelId].modelName;
                    let subviews = getSubviewsByModelName(parentModelName);
                    let subview = findSubview(subviews, model.subviewAbbreviation);

                    if(!subview) { return model; }

                    return {
                        ...model,
                        subviewAbbreviation: null,
                        subviewName: subview.name
                    };
                });
            });

            ui = modify(ui, 'loadedModels', (loadedModels) => {
                let modelsToLoad = reduce(loadedModels, (modelsToLoad, modelPrototype) => {
                    let modelName = modelPrototype.modelName,
                        modelId =  modelPrototype.modelId;

                    if(!(modelPrototype.modelName in action.value)) { return modelsToLoad; }

                    const merged = {
                        modelId,
                        modelName,
                        parentModelId: modelPrototype.parentModelId,
                        data: merge(
                            {},
                            action.value[modelName].stateModel,
                            modelPrototype
                        )
                    };

                    modelsToLoad.push(merged);

                    return modelsToLoad;
                }, []);

                return loadModels(loadedModels, {
                    models: modelsToLoad,
                    getModelOrNull,
                    getSubviewsByModelName
                });
            });

            if(action.isForCache) {
                ui = {
                    ...ui,
                    searchModels: reduce(action.value, (stack, modelConfig, modelName) => {
                        let { dataModel, stateModel } = modelConfig;

                        // if(modelName !== 'customers') {
                        //     return stack;
                        // }

                        if (!dataModel.isGlobalSearchEnabled) {
                            return stack;
                        }

                        if(!dataModel.searchFilter) {
                            return stack;
                        }

                        stack[modelName] = {
                            modelName,
                            results: stateModel.results,
                            resultParams: {
                                ...omit(stateModel.resultParams, ['filters']),
                                perPage: 5
                            }
                        };

                        return stack;
                    }, {})
                };
            }

            break;
    }

    return ui;
};


export {
    types as modelConfigActionTypes,
    reduceLoadedModelsUi,
    reduceModelConfigs,
    reduceModelCacheStatus,
    execute as fetchModelConfigs
};